import React, { Component } from 'react';
import TimeSelect from './timeSelect';
import MediaFilter from './popup/mediaFilter';
import AdvancedSearch from './popup/advancedSearch';
import MyAuthor from './popup/myAuthor';
import MyArticle from './popup/myArticle';
import HistoryLog from './popup/HistoryLog';
import { DiffSetting, ResetPassword } from './popup/userSetting';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { Link, withRouter } from 'react-router-dom';
import logo from '../img/lowi_logo.png'
import { connect } from 'react-redux';
import { userActions, inputKeyword, fetchMediaList, changeSMethodRedux, alertActions, errorActions, mediaListErrorCLean,tempDealLogOut,setStatus,getDate } from '../actions';
import { Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalBody } from 'reactstrap';
import usericon from '../img/user.png';
import Loader from 'react-loader-advanced';
import ErrorState from './widget/toolbar/errorState';
import { read_cookie,versionCookie } from '../helpers/cookieHelper';

const mapStateToProps = state => {
	return {
		sDate: state.search.sDate,
		eDate: state.search.eDate,
    	prekeyword: state.search.serachKeyword,
		keywordFromGuide: state.search.keywordFromGuide,
		abbKeyword: state.search.abbKeyword,
    	resultsTemplate: state.widget.resultsTemplate,
		mediaFetched: state.mediaLists.fetched,
		filterTypeFromRedux: state.search.filterTypeFromRedux,
		exact: state.search.exact,
		errorOpen: state.alert.open,
		errorMessage: state.alert.message,
		status:state.search.status,
		historyLog: state.search.savedHistoryLog,
		fetchCount: state.search.process_fetch_count
	};
};



const mapDispatchToProps = dispatch => {
  return {
	  getDate: (sdate, edate) => dispatch(getDate(sdate, edate)),
	  setStatus: (status) => dispatch(setStatus(status)),
	  tempDealLogOut:()=> dispatch(tempDealLogOut()),
	  logout: () => dispatch(userActions.logout()),
	  inputKeyword: (keyword,abbreviation,autophrase) => dispatch(inputKeyword(keyword, abbreviation,autophrase)),
	  fetchMediaList: () => dispatch(fetchMediaList()),
	  mediaListErrorCLean: () => dispatch(mediaListErrorCLean()),
	  changeSMethodRedux: (value) => dispatch(changeSMethodRedux(value)),
	  cleanError: () => dispatch(alertActions.clear()),
	  updateError: (open, code, message) => dispatch(errorActions.update(open, code, message)),
  };
};

const spinner = <div className="lds-ripple"><div></div><div></div></div>;

class HeaderComponent extends Component {
  constructor(props) {
	super(props);
	this.settingToggle = this.settingToggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.mediaFilterToggle = this.mediaFilterToggle.bind(this);
    this.adSearchToggle = this.adSearchToggle.bind(this);
    this.closeSearchModal = this.closeSearchModal.bind(this);
    this.changeKeywordFromModal = this.changeKeywordFromModal.bind(this);
	this.searchAlertToggle = this.searchAlertToggle.bind(this);
	this.handleClickMyMeida = this.handleClickMyMeida.bind(this);
	this.toggleSearchmethod = this.toggleSearchmethod.bind(this);
	this.changeSearchMethod = this.changeSearchMethod.bind(this);
	this.diffSetToggle = this.diffSetToggle.bind(this);
	this.passwordSetToggle = this.passwordSetToggle.bind(this);
	this.myAuthorToggle = this.myAuthorToggle.bind(this);
	this.myArticleToggle = this.myArticleToggle.bind(this);
    this.search = this.search.bind(this);
    this.logout = this.logout.bind(this);
	this.keyPress = this.keyPress.bind(this);

    this.state = {
		sDate:'',
		eDate:'',
		// nowCheck:"",
		isNewVersion:false,
		autophrase:false,
		settingDropdownOpen: false,
		mediaFilterOpen: false,
		adSearchOpen: false,
		myAuthorOpen: false,
		myAricleOpen: false,
		historyOpen:false,
		searchAlertOpen: false,
		searchmethodOpen: false,
		diffSetOpen: false,
		passwordSetOpen: false,
		keyword: '',
		keywordFromGuide: this.props.keywordFromGuide,
		disableSearch: true,
		controlByHeader: true,
		showMediaListError: false,
		devDisplay: false,
		status:this.props.status,
		// fakeHistoryLog:[],
	};

  }
  settingToggle() {
    this.setState(prevState=>({settingDropdownOpen: !prevState.settingDropdownOpen}));
  }
	toggleSearchmethod() {
		this.setState(prevState=>({searchmethodOpen: !prevState.searchmethodOpen}));
	}

	// clicke enter to start searching
	keyPress(e) {
		if (e.keyCode  === 13) this.search();
	}

  logout() {
	this.props.logout();
	this.props.tempDealLogOut();
  }
  mediaFilterToggle() {
    this.setState(prevState => ({
      mediaFilterOpen: !prevState.mediaFilterOpen
    }));
  }
  adSearchToggle() {
    this.setState(prevState => ({
      adSearchOpen: !prevState.adSearchOpen
    }));
  }
	myAuthorToggle() {
		this.setState(prevState => ({
			myAuthorOpen: !prevState.myAuthorOpen
		}));
	}
	myArticleToggle() {
		this.setState(prevState => ({
			myAricleOpen: !prevState.myAricleOpen
		}));
	}
	searchAlertToggle() {
		this.setState(prevState => ({
			searchAlertOpen: !prevState.searchAlertOpen
		}));
	}
  closeSearchModal() {
    this.setState({ adSearchOpen: false});
  }
  handleChange(event) {
    const value = event.target.value;
    //  configuration of the special charactere that we want to exclude
    // const regex = RegExp('^[a-zA-Z0-9\,\*\，]*[^<>%$&é"!è§()-_`ù=:;?./+]*$', 'g');
    // // remove the whitespace, and check if the string is empty or not
    // if (!value.replace(/\s/g, '').length) {
    //   console.log('----------------string only contains whitespace (ie. spaces, tabs or line breaks)----------------');
    //   this.setState({
    //     keyword: '',
    //     disableSearch: true
    //   });
    //   return;
    // }
    // // checking the regular expression
    // const isExpGood = regex.test(value);
    // console.log('isExpGood', isExpGood);
    // if (isExpGood) {
    //   this.setState({
    //     keyword: value,
    //     disableSearch: false
    //   });
    // } else {
    //   this.setState({
    //     disableSearch: true
    //   });
    //   // need to manage the last state (when only one character anymore we remove everything)
    //   this.setState(prevState =>  ({keyword: (value === 1) ? '' : prevState.keyword}))
    // }
    this.setState({keyword: value, controlByHeader: true});
  }

  //props.keyword => prekeyword
  search() {
	  	if(this.props.fetchCount === 0){
			if (this.state.keyword && this.state.keyword.length) {
				const abb = this.state.keyword === this.props.prekeyword ? this.props.abbKeyword : false;
				this.props.inputKeyword(this.state.keyword, abb,this.state.autophrase);
				this.timeHandler()
				this.props.history.push('/results');
			} else {
				this.setState({ searchAlertOpen: true});
			}
		}else{
			alert('資料處理中')
		}
  }

  timeHandler = () =>{
	  let s = this.state.sDate ? this.state.sDate : this.temp_timeformate(this.props.sDate)
	  let e = this.state.eDate ? this.state.eDate : this.temp_timeformate(this.props.eDate)
	  this.props.getDate(s,e)
	  this.props.setStatus(this.state.status)
  }

  temp_timeformate = (time) =>{
	  let transtime =time.substring(0, 4)+'/'+time.substring(4, 6)+'/'+time.substring(6,8)+' '+time.substring(9,14)
	  return transtime
  }

  handleTimeStatus = (status) =>{
	this.setState({ status:status })
  }

  setTime = (s,e) =>{
	  this.setState({sDate:s,eDate:e})
  }

  changeKeywordFromModal(keywordFromModal) {
    // user type new keyword in advanced search modal, then replace the keyword which showing in search box by keyword in redux
    this.setState({ keyword: keywordFromModal });
  }
  
  handleClickMyMeida() {
	  if (!this.props.mediaFetched) {
		  this.props.fetchMediaList();
		}
		this.mediaFilterToggle();
	}

	changeSearchMethod(value) {
		this.props.changeSMethodRedux(value);
	};
	diffSetToggle() {
		this.setState(prevState => ({diffSetOpen: !prevState.diffSetOpen}));
	}
	passwordSetToggle() {
		this.setState(prevState => ({passwordSetOpen: !prevState.passwordSetOpen}));
	}

	historyToggle=()=>{
		this.setState(prevState => ({historyOpen: !prevState.historyOpen}))
	}

	autophraseToggle = () => {
		this.setState(prevState => ({autophrase: !prevState.autophrase}));
	}

	VerCheckedHandle = ()=>{
		try {
			const latestVerNO = this.props.historyLog.length>0 ? this.props.historyLog[0] : null
			const version = read_cookie(versionCookie)
	
			const found = version.verlist.find(element => element === latestVerNO.version_no);
			if(latestVerNO){
				this.setState({
					isNewVersion: found ? false : true
				})

			}
		} catch (error) {
			console.log('Your cookie has been delete')
		}

	}

	componentDidMount(){
		this.VerCheckedHandle()
	}


	static getDerivedStateFromProps(nextProps, prevState) {
		const version = read_cookie(versionCookie)

		// change the current keyword display on the header
		if (nextProps.keywordFromGuide && nextProps.keywordFromGuide !== prevState.keywordFromGuide) {
			return {
				...prevState,
				keywordFromGuide: nextProps.keywordFromGuide,
				keyword: nextProps.keywordFromGuide
			};
		}else if(prevState.historyOpen === false && version ){
			// SAME AS COMPONENTDIDMOUNT :((
			const latestVerNO = nextProps.historyLog.length>0 ? nextProps.historyLog[0] : ''
			if(latestVerNO){
				const found = version.verlist.find(element => element === latestVerNO.version_no);
				return {
					...prevState,
					isNewVersion : !found ,
					historyOpen :  !found
				}
			}else{
				return{
					...prevState,
				}
			}

		}else{
			return null
		}
	}

  render() {
    return (
      <div className="neuf-header">
        <div className="neuf-logo">
		  <img src={logo} alt="neuf-logo"/>
        </div>
        <div className="search-group">
          <div className="search-item">
          <div className="mr-1 btn-group">
            <button type="button" aria-haspopup="true" aria-expanded="false" className="source customer-dropdown-button dropdown-toggle btn btn-secondary" onClick={this.handleClickMyMeida}>
				<span className="description">來源</span>
            </button>
          </div>
          </div>
          <div className="search-item">
            <div className="mr-1 btn-group">
              <button onClick={this.myAuthorToggle} type="button" aria-haspopup="true" aria-expanded="false" className="source customer-dropdown-button dropdown-toggle btn btn-secondary">
                <span className="description">作者</span>
              </button>
            </div>
          </div>
					<div className="search-item">
            <div className="mr-1 btn-group">

              <button onClick={this.myArticleToggle} type="button" aria-haspopup="true" aria-expanded="false" className="source customer-dropdown-button dropdown-toggle btn btn-secondary">
                <span className="description">文章</span>
              </button>
            </div>
          </div>
          <div className="search-item">
            <TimeSelect handleTimeStatus={this.handleTimeStatus} setTime={this.setTime}/>
          </div>

          <div className="search-item customer-input">
            <Input type="text" placeholder="輸入搜詢關鍵字" onKeyDown={this.keyPress} onChange={this.handleChange} value={this.state.keyword}/>
            <i className="fa fa-search" onClick={this.search}></i>
          </div>

		  <div className="search-item">
		  	<BootstrapSwitchButton
			  onstyle="primary"
			  offstyle="secondary"
			  width={100}
		      checked={this.state.autophrase}
    	      onlabel='精準搜尋'
   			  offlabel='概念搜尋'
    		  onChange={() => {this.autophraseToggle()}}
			/>
		  </div>
		  <div className="search-item">
          	<i className="icon-list icons d-block" onClick={this.adSearchToggle}></i>
		  </div>
        </div>
        <div className="setting">
          <Dropdown isOpen={this.state.settingDropdownOpen} toggle={this.settingToggle}>
            <DropdownToggle className="user-profile">
			  {this.state.isNewVersion
			  ? <div className='usericon-alert'>
			  		<img src={ usericon } alt="usericon"/>
					<span> </span>
				</div> 
			  : <img src={ usericon } alt="usericon"/>
			  }
            </DropdownToggle>
            <DropdownMenu style={{"transform": "translate3d(-55px, 54px, 0px)"}}>
              <DropdownItem onClick={this.diffSetToggle}>擴散度設定</DropdownItem>
			  <DropdownItem onClick={this.passwordSetToggle}>重置密碼</DropdownItem>
			  <DropdownItem onClick={this.historyToggle}>
			  	<div className="drop-item">
			  		歷史更版紀錄
					  {this.state.isNewVersion ? <div className='item-alert'> </div> : null}
			  	</div>
			  </DropdownItem>
              <Link to="/login">
                <DropdownItem onClick={this.logout}>登出</DropdownItem>
              </Link>
            </DropdownMenu>
          </Dropdown>
        </div>
		
		<Modal size='sm' isOpen={this.state.diffSetOpen} toggle={this.diffSetToggle}>
			<DiffSetting cancel={this.diffSetToggle} actions={{onSubmitValue: () => {}}} />
		</Modal>

		<Modal size='mid' isOpen={this.state.historyOpen} toggle={this.historyToggle}>
			<HistoryLog toggle={this.historyToggle} historyLog={this.props.historyLog}/>
		</Modal>
		
		<Modal size='sm' isOpen={this.state.passwordSetOpen} toggle={this.passwordSetToggle}>
			<ResetPassword cancel={this.passwordSetToggle} />
		</Modal>

		<Modal size='lg' isOpen={this.state.mediaFilterOpen} toggle={this.mediaFilterToggle}>
			<Loader show={!this.props.mediaFetched} message={spinner} hideContentOnLoad={true} >
				{this.props.mediaFetched ? <MediaFilter closeModal={this.mediaFilterToggle} /> : null }
			</Loader>
		</Modal>

        <Modal className='adsearch-modal' size='lg' isOpen={this.state.adSearchOpen} toggle={this.adSearchToggle}>
        	<AdvancedSearch autophrase={this.state.autophrase}  closeModal={this.closeSearchModal} autophraseToggle ={this.autophraseToggle} changeBoxKeyword = {this.changeKeywordFromModal}/>
        </Modal>
		
		<Modal className='adsearch-modal' size='lg' isOpen={this.state.myAuthorOpen} toggle={this.myAuthorToggle}>
        	<MyAuthor closeModal={this.myAuthorToggle} />
        </Modal>
		
		<Modal className='adsearch-modal' size='lg' isOpen={this.state.myAricleOpen} toggle={this.myArticleToggle}>
        	<MyArticle closeModal={this.myArticleToggle} />
        </Modal>

		<Modal size='mid' className='search-modal' isOpen={this.state.searchAlertOpen} toggle={this.searchAlertToggle}>
			<ModalBody>
				搜尋欄位不可為空白，請輸入搜尋關鍵字
			</ModalBody>
		</Modal>
		
		<Modal size='mid' isOpen={this.state.devDisplay} toggle={this.handleClickMyMeida}>
			<ErrorState message={'此功能開發中'} onToggle={this.handleClickMyMeida} />
		</Modal>
		
		<Modal size='mid' isOpen={this.props.errorOpen} toggle={this.errorClean}>
			<ModalBody>
				{this.props.errorMessage}
			</ModalBody>
		</Modal>
		
      </div>
    );
  }
}

const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/header.js